import { Pipe, PipeTransform } from '@angular/core';

import { TrackAuthority } from '../models/trackauthority';
import { DisplayStatus } from '../models/displaystatus.enum';
import { FilterStatus } from '../models/filterstatus.enum';
import { EICSTatus } from '../models/eic-status.enum';

@Pipe({
    name: 'authorityFilter',
    pure: false //If the authority list is replaced rather manipulate then we can set pure to 'true' (Refer main.component.ts.userListUpdated())
})
export class AuthorityFilterPipe implements PipeTransform {
    transform(items: TrackAuthority[], filter: FilterStatus): TrackAuthority[] {
        return items.filter(auth => {
             
            if(filter === FilterStatus.RELEASED){
             return auth.displayStatus === DisplayStatus.RELEASED || (!auth.isLoggedUserPrimary && [EICSTatus.RELEASED,EICSTatus.REJECTED,EICSTatus.CANCELLED].indexOf(auth.loggedInEICDetail.status) >= 0);
            }
            if(filter === FilterStatus.CANCELLED){
                return auth.displayStatus === DisplayStatus.CANCELLED || auth.displayStatus === DisplayStatus.ERROR;
            }
            
            if( auth.displayStatus === DisplayStatus.REJECTED){
                return filter === FilterStatus.REJECTED 
                || (filter === FilterStatus.OPEN && auth.lastUpdatedDate !== undefined && new Date().getTime() - auth.lastUpdatedDate.getTime() < 7200*1000) ;
            }

            if(filter === FilterStatus.OPEN) {
                if(auth.isLoggedUserPrimary){
                    return (auth.displayStatus === DisplayStatus.REQUEST_SUBMITTED || auth.displayStatus === DisplayStatus.PENDING || auth.displayStatus === DisplayStatus.APPROVED || auth.displayStatus === DisplayStatus.ACTIVE);
                } else{
                    return (auth.displayStatus === DisplayStatus.REQUEST_SUBMITTED || auth.displayStatus === DisplayStatus.PENDING || auth.displayStatus === DisplayStatus.APPROVED || auth.displayStatus === DisplayStatus.ACTIVE) && [EICSTatus.RELEASED,EICSTatus.REJECTED,EICSTatus.CANCELLED].indexOf(auth.loggedInEICDetail.status) < 0;
                }
            }
        }) ;
    }
  
}